import React, { useEffect, useState } from 'react';
import { GetCompanyWiseInventoryData } from '../../screen/distributor/action/util_action';
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from '@mui/material';
import NoData from './NoData';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const CompanyWiseInventory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isLoading, setIsLoading] = useState(false);

  const [companies, setCompanies] = useState([]);

  const getCompanyWiseInventory = async () => {
    setIsLoading(true);
    const { error, data } = await GetCompanyWiseInventoryData();
    setIsLoading(false);
    if (!error) {
      setCompanies(data);
    }
  };
  useEffect(() => {
    getCompanyWiseInventory();
  }, []);

  return (
    <Box sx={{ position: 'relative' }}>
      <Container
        maxWidth='true'
        sx={{ pl: '1rem', py: '1rem' }}
      >
        <Typography variant='h4'>Company Wise Inventory </Typography>
        <Divider sx={{ mt: '1rem', mb: '2rem' }} />

        {isLoading ? (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height={300}
          >
            <CircularProgress />
          </Box>
        ) : !isMobile ? (
          <Paper sx={{ width: '100%', mb: 2, mt: '1rem' }}>
            {companies.length === 0 ? (
              <NoData text='No Inventory found ' />
            ) : (
              <TableContainer>
                <Table aria-label='simple table'>
                  <TableHead
                    sx={{ backgroundColor: 'rgba(217, 217, 217, .5)' }}
                  >
                    <TableRow>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        #
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Company Name
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Last Invoice Date
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        UOM
                      </TableCell>
                      {/* <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Total Quantity
                      </TableCell> */}
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Available Quantity
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Blocked Quantity
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {companies.length > 0 &&
                      companies.map((row, index) => {
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              navigate(`/distributor/inventory`, {
                                state: { companyId: row?.company_id },
                              });
                            }}
                          >
                            <TableCell align='center'>{index + 1}</TableCell>
                            <TableCell align='center'>
                              {row?.company_name}
                            </TableCell>
                            <TableCell align='center'>
                              {row?.last_invoice_date || '-'}
                            </TableCell>
                            <TableCell align='center'>
                              {row?.total_quantity?.unit || '-'}
                            </TableCell>
                            {/* <TableCell align='center'>
                              {row?.total_quantity?.quantity_in_metric_ton ||
                                '-'}
                            </TableCell> */}
                            <TableCell align='center'>
                              {row?.allocable_quantity
                                ?.quantity_in_metric_ton || '-'}
                            </TableCell>
                            <TableCell align='center'>
                              {row?.blocked_quantity?.quantity_in_metric_ton ||
                                '-'}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        ) : (
          <Box>
            {companies.length === 0 ? (
              <NoData text='No Inventory found ' />
            ) : (
              <Box sx={{ mt: 2 }}>
                {companies.length > 0 &&
                  companies.map((row, index) => {
                    return (
                      <Card
                        key={index}
                        sx={{
                          cursor: 'pointer',
                          mb: 2,
                          boxShadow: 'none',
                          border: '1px solid rgba(0, 0, 0, 0.12)',
                          borderRadius: '5px',
                        }}
                        onClick={() => {
                          navigate(`/distributor/inventory`, {
                            state: { companyId: row?.company_id },
                          });
                        }}
                      >
                        <CardContent>
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Grid
                              item
                              xs={3}
                              sm={2}
                            >
                              <Box>
                                <img
                                  style={{
                                    width: '100%',
                                    borderRadius: '5px',
                                  }}
                                  src={row?.company_logo}
                                  alt={row?.company_name}
                                />
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={9}
                              sm={10}
                            >
                              <Typography
                                sx={{ fontWeight: 'bold', fontSize: '15px' }}
                              >
                                {row?.company_name}
                              </Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <Box>
                                  {row?.last_invoice_date && (
                                    <Typography variant='body2'>
                                      Last Invoice Date:{' '}
                                      {row?.last_invoice_date || '0'}
                                    </Typography>
                                  )}
                                  {row?.total_quantity && (
                                    <Typography variant='body2'>
                                      UoM: {row?.total_quantity?.unit || '-'}
                                    </Typography>
                                  )}
                                  {/* {row?.total_quantity && (
                                    <Typography variant='body2'>
                                      Total Qty:{' '}
                                      {row?.total_quantity
                                        ?.quantity_in_metric_ton || '0'}
                                    </Typography>
                                  )} */}
                                  {row?.allocable_quantity && (
                                    <Typography variant='body2'>
                                      Available Qty:{' '}
                                      {row?.allocable_quantity
                                        ?.quantity_in_metric_ton || '0'}
                                    </Typography>
                                  )}
                                  {row?.blocked_quantity && (
                                    <Typography variant='body2'>
                                      Blocked Qty:{' '}
                                      {row?.blocked_quantity
                                        ?.quantity_in_metric_ton || '0'}
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    );
                  })}
              </Box>
            )}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default CompanyWiseInventory;
